import { Inject, Injectable } from '@angular/core'; // Sorted alphabetically
import { Observable } from 'rxjs';

import { CUSTOMER_LOOKUP_STRATEGY } from '../injection-tokens'; // Moved up
import { CustomerMetadata } from '../models/customer-metadata.model';
import { CustomerLookupStrategy } from '../strategies/customer-lookup.strategy';

/**
 * Service responsible for retrieving customer metadata.
 * It delegates the actual lookup logic to the injected CustomerLookupStrategy.
 */
@Injectable()
export class CustomerDataService {
  constructor(
    @Inject(CUSTOMER_LOOKUP_STRATEGY)
    private strategy: CustomerLookupStrategy
  ) {}

  /**
   * Retrieves customer metadata for the specified domain using the configured strategy.
   * @param domain The domain to look up customer data for.
   * @returns An observable emitting the customer metadata.
   */
  getCustomerData(domain: string): Observable<CustomerMetadata> {
    // Basic validation could be added here if desired
    return this.strategy.lookup(domain);
  }
}
